import React from 'react'
import PdfViagemProtocolo from './components/PDF'

const ViagemProtocolo: React.FC = () => {

    return <PdfViagemProtocolo />

}

export default ViagemProtocolo